import React from "react";
import PropTypes from "prop-types";

import styles from "./SettingsHeader.css";

export default function SettingsHeader({ title, description, children }) {
  return (
    <header className={styles.root}>
      <div className={styles.wrapper}>
        <h2 className={styles.title}>{title}</h2>

        <div className={styles.tools}>{children}</div>
      </div>

      {description && <p className={styles.description}>{description}</p>}
    </header>
  );
}

SettingsHeader.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
};
